// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-list {
  width: 100%;
  /* padding: 16px; */
}

.chat-item {
  display: flex;
  padding: 16px;
  border-radius: 12px;
  margin-bottom: 12px;
  background: #273142;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease;
}

.chatViewHead {
  display: flex;
  justify-content: space-between;
}
.chat-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.profile-image .avatar {
  width: 48px;
  height: 48px;
  background-color: #e9ecef;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #495057;
  font-weight: 600;
  margin-right: 16px;
}

.chat-info {
  flex: 1 1;
}

.chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.chat-header h3 {
  margin: 0;
  font-size: 16px;
}

.chat-name {
  font-weight: 600;
  font-size: 15px;
  color: #cbcbcb;
  display: flex;
  align-items: center;
  gap: 8px;
}

.unread-indicator {
  width: 8px;
  height: 8px;
  background-color: #7048e8;
  border-radius: 50%;
}

.time {
  font-size: 13px;
  color: #868e96;
}

.last-message {
  margin: 0;
  color: #7e7e7e;
  font-size: 14px;
  line-height: 1.4;
}

.search-bar {
  padding: 12px 16px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  background: white;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.search-bar input {
  border: none;
  outline: none;
  width: 100%;
  padding: 8px;
  font-size: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatList.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ,eAAe;AACjB","sourcesContent":[".chat-list {\n  width: 100%;\n  /* padding: 16px; */\n}\n\n.chat-item {\n  display: flex;\n  padding: 16px;\n  border-radius: 12px;\n  margin-bottom: 12px;\n  background: #273142;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  transition: transform 0.2s ease;\n}\n\n.chatViewHead {\n  display: flex;\n  justify-content: space-between;\n}\n.chat-item:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.profile-image .avatar {\n  width: 48px;\n  height: 48px;\n  background-color: #e9ecef;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #495057;\n  font-weight: 600;\n  margin-right: 16px;\n}\n\n.chat-info {\n  flex: 1;\n}\n\n.chat-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 4px;\n}\n\n.chat-header h3 {\n  margin: 0;\n  font-size: 16px;\n}\n\n.chat-name {\n  font-weight: 600;\n  font-size: 15px;\n  color: #cbcbcb;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.unread-indicator {\n  width: 8px;\n  height: 8px;\n  background-color: #7048e8;\n  border-radius: 50%;\n}\n\n.time {\n  font-size: 13px;\n  color: #868e96;\n}\n\n.last-message {\n  margin: 0;\n  color: #7e7e7e;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.search-bar {\n  padding: 12px 16px;\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  background: white;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n}\n\n.search-bar input {\n  border: none;\n  outline: none;\n  width: 100%;\n  padding: 8px;\n  font-size: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
